import React, { useEffect } from 'react';
import { Layout } from 'app/blocks/blocks';
import { compose } from 'app/blocks/common/utils';
import OnlineOpenPaymentContext from './OnlineOpenPaymentContext';
import './Payment.scss';
import PaymentStepEnum from './PaymentStepEnum';
import ReviewStep from './Review/ReviewStep';
import ReviewFinalChargesStep from './ReviewFinalCharges/ReviewFinalChargesStep';
// eslint-disable-next-line import/order
import PageEnum from 'app/blocks/common/PageEnum';

const pages = {
    [PaymentStepEnum.REVIEW_FINAL_CHARGES]: PageEnum.ONLINE_OPEN_ORDER_REVIEW,
    [PaymentStepEnum.REVIEW]: PageEnum.ONLINE_OPEN_ORDER_REVIEW,
};

function Payment({ isProcessing, onLoadSubstep, substep }) {
    useEffect(() => {
        if (onLoadSubstep && typeof onLoadSubstep === 'function') {
            const page = pages[substep];
            onLoadSubstep(substep, page);
        }
    }, [onLoadSubstep, substep]);

    if (isProcessing) {
        return <Layout isLoading />;
    }
    if (substep === PaymentStepEnum.REVIEW_FINAL_CHARGES) {
        return <ReviewFinalChargesStep />;
    }
    if (substep === PaymentStepEnum.REVIEW) {
        return <ReviewStep />;
    }

    return null;
}

export default compose(
    OnlineOpenPaymentContext.withProvider,
    OnlineOpenPaymentContext.withContext(state => ({
        isProcessing: state.isProcessing,
    })),
)(Payment);
